import Sortable from 'sortablejs';
import type { QueueItem } from './api';

export interface RenderContext {
  isDj: boolean;
  botUserId: number;
  resolveUser: (userId: number) => string;
  onDelete: (itemId: string) => void;
  onReorder: (orderedIds: string[]) => void;
}

let _sortable: Sortable | null = null;

export function renderQueue(
  listEl: HTMLUListElement,
  emptyEl: HTMLElement,
  items: QueueItem[],
  ctx: RenderContext,
): void {
  // Destroy stale Sortable instance before re-rendering
  if (_sortable !== null) {
    _sortable.destroy();
    _sortable = null;
  }
  listEl.innerHTML = '';
  if (items.length === 0) {
    emptyEl.classList.remove('hidden');
    return;
  }
  emptyEl.classList.add('hidden');

  for (const item of items) {
    const li = document.createElement('li');
    li.className = 'q-row';
    li.dataset.id = item.id;

    if (ctx.isDj) {
      const handle = document.createElement('span');
      handle.className = 'q-handle';
      handle.textContent = '≡';
      li.appendChild(handle);
    }

    const title = document.createElement('span');
    title.className = 'q-title';
    title.textContent = item.track.title.length > 40
      ? item.track.title.slice(0, 40) + '…'
      : item.track.title;
    li.appendChild(title);

    const req = document.createElement('span');
    req.className = 'q-requester';
    if (item.track.requested_by_id === ctx.botUserId) {
      req.classList.add('radio');
      req.textContent = '🎵 Radio';
    } else {
      req.textContent = ctx.resolveUser(item.track.requested_by_id);
    }
    li.appendChild(req);

    if (ctx.isDj) {
      const del = document.createElement('button');
      del.className = 'q-delete';
      del.type = 'button';
      del.textContent = '✕';
      del.addEventListener('click', () => ctx.onDelete(item.id));
      li.appendChild(del);
    }
    listEl.appendChild(li);
  }

  if (ctx.isDj) {
    _sortable = Sortable.create(listEl, {
      handle: '.q-handle',
      animation: 150,
      onEnd: () => {
        const ids = Array.from(listEl.children).map(
          (el) => (el as HTMLLIElement).dataset.id!,
        );
        ctx.onReorder(ids);
      },
    });
  }
}
